<div>
    {{ currentDateTime | date: format}}
</div>
